import { render } from "./ClinicSchedulesTab.vue?vue&type=template&id=cb598b4e&scoped=true"
import script from "./ClinicSchedulesTab.js?vue&type=script&lang=js&external"
export * from "./ClinicSchedulesTab.js?vue&type=script&lang=js&external"

import "./ClinicSchedulesTab.vue?vue&type=style&index=0&id=cb598b4e&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cb598b4e"]])

export default __exports__